import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-wrap gap-2',
    tag: '!heading-s'
  }
});
